import React, { useEffect, useState } from "react";
// import "@fortawesome/fontawesome-free/css/all.min.css";

const ProductAssignmentDashboard = () => {
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [assignments, setAssignments] = useState([]);
  const [logs, setLogs] = useState([]);
  const [categories, setCategories] = useState([]);
  const [pages] = useState([
    { id: "collection", name: "Collection Page" },
    { id: "product", name: "Product Page" },
    { id: "cart", name: "Cart Page" },
    { id: "before_checkout", name: "Before Checkout Page" },
    { id: "checkout", name: "Checkout Page" },
    { id: "post_purchase", name: "Post-Purchase Page" },
  ]);

  const [selectedPage, setSelectedPage] = useState("collection");
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [showLogs, setShowLogs] = useState(false);
  const [showAssignmentsPanel, setShowAssignmentsPanel] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [bulkActionPage, setBulkActionPage] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 12;

  useEffect(() => {
    generateMockData();
  }, []);

  useEffect(() => {
    filterProducts();
  }, [searchQuery, selectedCategory, selectedStatus, selectedPage, products, assignments]);

  const generateMockData = () => {
    const mockProducts = [];
    const cats = ["Electronics", "Clothing", "Home", "Books", "Toys"];
    setCategories(cats);
    for (let i = 1; i <= 50; i++) {
      mockProducts.push({
        id: `prod_${i}`,
        name: `Product ${i}`,
        category: cats[Math.floor(Math.random() * cats.length)],
        price: (Math.random() * 100 + 10).toFixed(2),
        stock: Math.floor(Math.random() * 100),
        image: `https://picsum.photos/200/200?random=${i}`,
      });
    }
    setProducts(mockProducts);

    const mockAssignments = [];
    for (let i = 1; i <= 20; i++) {
      const productId = `prod_${Math.floor(Math.random() * 50) + 1}`;
      const pageId = pages[Math.floor(Math.random() * pages.length)].id;
      if (!mockAssignments.some((a) => a.productId === productId && a.pageId === pageId)) {
        mockAssignments.push({ id: `assign_${i}`, productId, pageId });
      }
    }
    setAssignments(mockAssignments);

    const mockLogs = [];
    const actions = ["assigned", "unassigned"];
    const users = ["admin", "manager", "editor"];
    for (let i = 1; i <= 15; i++) {
      const product = mockProducts[Math.floor(Math.random() * mockProducts.length)];
      const page = pages[Math.floor(Math.random() * pages.length)];
      const action = actions[Math.floor(Math.random() * actions.length)];
      const date = new Date(Date.now() - Math.floor(Math.random() * 7 * 24 * 60 * 60 * 1000));
      mockLogs.push({
        id: `log_${i}`,
        date,
        productId: product.id,
        productName: product.name,
        pageId: page.id,
        pageName: page.name,
        action,
        user: users[Math.floor(Math.random() * users.length)],
      });
    }
    setLogs(mockLogs.sort((a, b) => b.date - a.date));
  };

  const getAssignedPages = (productId) =>
    assignments.filter((a) => a.productId === productId).map((a) => a.pageId);

  const isAssigned = (productId, pageId) =>
    assignments.some((a) => a.productId === productId && a.pageId === pageId);

  const getPageName = (pageId) => pages.find((p) => p.id === pageId)?.name || "";

  const filterProducts = () => {
    setCurrentPage(1);
    const result = products.filter((product) => {
      const matchSearch =
        product.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
        product.category.toLowerCase().includes(searchQuery.toLowerCase());
      const matchCategory = !selectedCategory || product.category === selectedCategory;
      let matchStatus = true;
      if (selectedStatus === "assigned") {
        matchStatus = getAssignedPages(product.id).length > 0;
      } else if (selectedStatus === "unassigned") {
        matchStatus = getAssignedPages(product.id).length === 0;
      }
      let matchPage = true;
      if (selectedPage) {
        matchPage = isAssigned(product.id, selectedPage);
      }
      return matchSearch && matchCategory && matchStatus && matchPage;
    });
    setFilteredProducts(result);
  };

  const toggleProductSelection = (productId) => {
    setSelectedProducts((prev) =>
      prev.includes(productId) ? prev.filter((id) => id !== productId) : [...prev, productId]
    );
  };

  const formatDate = (date) => new Date(date).toLocaleString();

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white shadow-sm p-4 flex justify-between items-center">
        <h1 className="text-2xl font-bold text-gray-900">Product Assignment Dashboard</h1>
        <div className="flex gap-4 text-sm text-gray-600">
          <button onClick={() => setShowLogs(true)} className="hover:text-blue-600">
            <i className="fas fa-history mr-1" /> View Logs
          </button>
          <button onClick={() => alert("Exported")} className="hover:text-blue-600">
            <i className="fas fa-file-export mr-1" /> Export
          </button>
        </div>
      </header>

      <main className="p-6">
        {/* Search and filters, products grid, bulk actions, pagination, logs, assignments, etc. */}
        <p className="text-gray-500">(More UI and logic follows...)</p>
      </main>

      {showLogs && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded p-4 max-w-7xl w-full overflow-auto max-h-[80vh]">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-lg font-semibold">Assignment Logs</h2>
              <button onClick={() => setShowLogs(false)}>
                <i className="fas fa-times text-gray-500 hover:text-gray-800" />
              </button>
            </div>
            <table className="min-w-full text-sm text-left">
              <thead className="bg-gray-100">
                <tr>
                  <th className="p-2">Date</th>
                  <th className="p-2">Product</th>
                  <th className="p-2">Action</th>
                  <th className="p-2">Page</th>
                  <th className="p-2">User</th>
                </tr>
              </thead>
              <tbody>
                {logs.map((log) => (
                  <tr key={log.id} className="border-t">
                    <td className="p-2">{formatDate(log.date)}</td>
                    <td className="p-2 font-medium text-gray-900">{log.productName}</td>
                    <td className="p-2">
                      <span className={`px-2 py-1 rounded-full text-xs font-semibold ${
                        log.action === "assigned"
                          ? "bg-green-100 text-green-800"
                          : log.action === "unassigned"
                          ? "bg-red-100 text-red-800"
                          : "bg-blue-100 text-blue-800"
                      }`}>
                        {log.action.replace("_", " ")}
                      </span>
                    </td>
                    <td className="p-2">{log.pageName}</td>
                    <td className="p-2">{log.user}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductAssignmentDashboard;
